// extracted by mini-css-extract-plugin
export var bg = "style-module--bg--593c4";
export var vid = "style-module--vid--21bfa";
export var video = "style-module--video--5d327";